import apiClient from './client'
import { LoginRequest, LoginResponse, User, UserContextResponse, ContextSelectionRequest } from '../types/auth'
import { createLogger } from '../utils/logger'

const logger = createLogger('authApi')

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', data)
    return response.data
  },

  refresh: async (refreshToken: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data
  },

  validate: async (): Promise<User> => {
    const response = await apiClient.get<{ valid: boolean; user: User }>('/auth/validate')
    if (!response.data.valid || !response.data.user) {
      throw new Error('Token inválido')
    }
    return response.data.user
  },

  getUserContext: async (): Promise<UserContextResponse> => {
    const response = await apiClient.get<UserContextResponse>('/auth/context')
    return response.data
  },

  selectContext: async (data: ContextSelectionRequest): Promise<void> => {
    // Por enquanto apenas armazena no localStorage
    // Futuramente pode ter endpoint no backend para validar
    localStorage.setItem('user_context', JSON.stringify(data))
  },

  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/auth/logout')
    } catch (error) {
      // Ignorar erro se o endpoint não existir ainda
      logger.warn('Logout endpoint not available')
    }
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/auth/forgot-password', { email })
    return response.data
  },

  resetPassword: async (token: string, novaSenha: string): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/auth/reset-password', {
      token,
      nova_senha: novaSenha,
    })
    return response.data
  },

  updatePreferences: async (idEmpresa: number, ui: any): Promise<void> => {
    await apiClient.put('/ui/preferences', { id_empresa: idEmpresa, ui })
  },
}

